module.exports = __webpack_public_path__ + "img/icon-quit.05cf2a24.svg";